/**
 * Delivery Settings - local persistence
 *
 * Buffer days default + which Calendar is "active" for delivery-date
 * blocking are pure UI preferences with no dedicated backend endpoint, so
 * they stay in localStorage. Calendars/Holidays and buffer-days
 * configuration rules are backend-persisted — see ../api/dataverse.ts and
 * ../api/bufferDays.ts.
 */

import { DEFAULT_BUFFER_DAYS, DELIVERY_SETTINGS_STORAGE_KEY } from '../constants';
import { IDeliverySettings } from '../types';

export const getDeliverySettingsApi = async (): Promise<IDeliverySettings> => {
  try {
    const raw = localStorage.getItem(DELIVERY_SETTINGS_STORAGE_KEY);
    if (!raw) return { bufferDays: DEFAULT_BUFFER_DAYS };
    return { bufferDays: DEFAULT_BUFFER_DAYS, ...JSON.parse(raw) };
  } catch {
    return { bufferDays: DEFAULT_BUFFER_DAYS };
  }
};

export const saveDeliverySettingsApi = async (settings: IDeliverySettings): Promise<IDeliverySettings> => {
  localStorage.setItem(DELIVERY_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  return settings;
};
